<template>
  <div>
    <ul class="select-option">
      <li>
        <span class="select-title">查询日期：</span>
        <el-date-picker
          v-model="searchDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        />
      </li>
      <li v-if="checkPermission('系统报表:计算', permList)">
        <span class="select-title">计算日期：</span>
        <el-date-picker
          v-model="calculationDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        />
      </li>
      <li>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="init"
        >
          查询
        </el-button>
        <el-button
          v-if="checkPermission('系统报表:计算', permList)"
          type="primary"
          icon="el-icon-search"
          @click="calculation"
        >
          计算
        </el-button>

        <el-button
          type="primary"
          icon="iconfont icon-daochu"
          @click="exportExcel"
        >
          导出
        </el-button>
      </li>
    </ul>
    <el-table
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%"
      max-height="680"
      :span-method="objectSpanMethod"
      :row-style="rowStyle"
    >
      <el-table-column
        prop="date"
        label="日期"
        width="100"
        align="center"
      />

      <el-table-column
        prop="name"
        label="姓名"
        width="100"
        align="center"
      />
      <el-table-column
        prop="preScreenSendCaseNum"
        label="初筛派案数"
        width="100"
        align="center"
      />

      <el-table-column
        prop="preScreenNum"
        label="初筛数量"
        width="90"
        align="center"
      />
      <el-table-column
        prop="initialTrialCaseNum"
        label="资料初审派案数"
        width="130"
        align="center"
      />

      <el-table-column
        prop="dataPreReviewNum"
        label="资料初审数量"
        width="120"
        align="center"
      />
      <el-table-column
        prop="investigationsNum"
        label="调查初审派案数"
        width="120"
        align="center"
      />

      <el-table-column
        prop="preFirstTrialNum"
        label="调查初审数量"
        width="120"
        align="center"
      />
      <el-table-column
        prop="approvedCasesNum"
        label="审批派案数"
        width="100"
        align="center"
      />

      <el-table-column
        prop="approvalsNum"
        label="审批通过"
        width="100"
        align="center"
      />
      <el-table-column
        prop="completionRate"
        label="达成率"
        width="70"
        align="center"
      />

      <el-table-column
        prop="withdrawNum"
        label="撤案"
        width="50"
        align="center"
      />
      <el-table-column
        prop="preScreenRefuseNum"
        label="初筛不予互助"
        width="90"
        align="center"
      />

      <el-table-column
        prop="firstTrialRefuseNum"
        label="初审不予互助"
        width="90"
        align="center"
      />
      <el-table-column
        prop="reviewRefuseNum"
        label="复审不予互助"
        width="90"
        align="center"
      />

      <el-table-column
        prop="approvedNum"
        label="已审批数量"
        width="90"
        align="center"
      />
    </el-table>
    <div style="text-align: center; margin-top: 25px">
      <el-pagination
        background
        layout="total,prev, pager, next, jumper"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AuditPostReport',
  data() {
    return {
      loading: false,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      startDate: null,
      endDate: null,
      searchDate: null,
      calculationDate: null,
      tableData: [],
      arr1: []
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    })
  },

  mounted() {
    this.init()
  },

  methods: {
    /**
     * 页面初始化数据
     */
    init() {
      const vm = this

      vm.loading = true
      if (vm.searchDate != null) {
        vm.startDate = vm.searchDate[0]
        vm.endDate = vm.searchDate[1]
      } else {
        vm.startDate = null
        vm.endDate = null
      }
      vm.axios
        .get(vm.homePath() + '/report/audit/list?_t=' + new Date().valueOf(), {
          params: {
            startDate: vm.startDate,
            endDate: vm.endDate,
            limit: vm.pageSize,
            page: vm.pageIndex
          }
        })
        .then((response) => {
          const data = response.data
          vm.loading = false
          if (data.status == '000000') {
            vm.arr1 = []
            this.setdates(data.page.records)
            vm.tableData = data.page.records
            vm.totalPage = data.page.total
          } else {
            vm.tableData = []
            vm.totalPage = 0
            vm.arr1 = []

            vm.$alert(data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 计算
     */
    calculation() {
      const vm = this
      if (vm.calculationDate == null) {
        vm.$alert('请选择计算日期', '提示')
      } else {
        const date = new Date()
        date.setTime(date.getTime() - 3600 * 1000 * 24)
        if (date.getTime() > Date.now()) {
          vm.$alert('计算日期不能大于等于今天', '提示')
        } else {
          var url = vm.homePath() + '/report/accountingReports'
          url += '?startDate=' + vm.calculationDate + '&endDate=&type=' + 1 + '&_t=' + new Date().valueOf()
          vm.axios
            .get(url)
            .then((response) => {
              const data = response.data
              if (data.status == '000000') {
                vm.$alert('数据计算中...,请稍后查询！', '提示')
              } else {
                vm.$alert(data.message || '服务器繁忙，请稍后重试', '提示')
              }
            })
            .catch((error) => console.log(error))
        }
      }
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.init()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.init()
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.arr1[rowIndex]
        const _col = this.arr1[rowIndex] > 0 ? 1 : 0
        return [_row, _col]
      }
    },
    setdates(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (i === 0) {
          this.arr1.push(1)
          this.pos = 0
        } else {
          // 判断这一条和上一条id是否相同
          if (arr[i].date === arr[i - 1].date) {
            this.arr1[this.pos] += 1
            this.arr1.push(0)
          } else {
            this.arr1.push(1)
            this.pos = i
          }
        }
      }
    },
    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },
    exportExcel() {
      const vm = this
      if (vm.searchDate != null) {
        vm.startDate = vm.searchDate[0]
        vm.endDate = vm.searchDate[1]
      }
      let url = vm.homePath() + '/report/audit/getReport'
      url +=
        '?startDate=' +
        (vm.startDate == null ? '' : vm.startDate) +
        '&endDate=' +
        (vm.endDate == null ? '' : vm.endDate) +
        '&_t=' +
        new Date().valueOf()
      window.location.href = url
    }
  }
}
</script>

<style>
.select-title {
  font-size: 14px;
  font-weight: 700;
}

.select-option li {
  float: left;
  margin: 10px;
}

.select-input {
  width: auto;
}

.el-table td,
.el-table th {
  padding: 6px 0px;
}

.el-table th {
  color: #333;
  font-weight: bold;
  text-align: center;
}

.red {
  color: red;
}
</style>
